import React from 'react';
import EventList from '../components/EventList';
import { eventsAPI } from '../services/api';

const AllEvents = () => {
  return (
    <EventList 
      fetchEvents={eventsAPI.getAllEvents} 
      title="All Events" 
    />
  );
};

export default AllEvents;